import React from 'react';
import {
  ConfirmationDialog,
  ConfirmationDialogProps,
} from './confirmationDialog';

type InformationDialogProps = Pick<
  ConfirmationDialogProps,
  | 'isOpen'
  | 'title'
  | 'subtitle'
  | 'extraClasses'
  | 'headerClasses'
  | 'footerClasses'
  | 'submitLabel'
  | 'formId'
  | 'contentCss'
> & {
  onClose: () => void;
};

export const InformationDialog: React.FC<
  React.PropsWithChildren<InformationDialogProps>
> = (props) => <ConfirmationDialog {...props} hideCancelBtn />;
